/**
 * Facts about how the auxiliary passes encode their data, shared by the code that *renders* them
 * and the code that *describes* them to the model.
 *
 * These two must never disagree. Telling the model "darker is nearer" while the renderer writes the
 * opposite silently inverts every depth cue — haze on the foreground, sharp focus on the horizon —
 * and the failure looks like the model simply being bad at its job. Keeping the constants here, in a
 * module with no Three.js dependency, lets both sides import the same source of truth without
 * dragging the renderer into the pure prompt layer.
 */

/**
 * `THREE.MeshDepthMaterial` renders near geometry bright and far geometry dark. The depth pass
 * therefore clears to black, so sky reads as infinitely distant rather than closest.
 */
export const DEPTH_NEAR_IS_BRIGHT = true;
